import { useEffect, lazy, Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";


const DifferentiatorStrip = lazy( () => import("@/components/DifferentiatorStrip"));
const ProblemSection = lazy( () => import("@/components/ProblemSection"));
const HowItWorksSection = lazy( () => import("@/components/HowItWorksSection"));
const WhyFlipSection = lazy( () => import("@/components/WhyFlipSection"));
const UseCasesSection = lazy( () => import("@/components/UseCasesSection"));
const ComparisonTable = lazy( () => import("@/components/ComparisonTable"));
const DemoCTAModule = lazy( () => import("@/components/DemoCTAModule"));
const BusinessFaq = lazy(() => import("@/components/BusinessFaq"));
const FinalCTASection = lazy( () => import("@/components/FinalCTASection"));
const LatestBlogPosts = lazy( () => import("@/components/LatestBlogPosts"));

import SEO, { generateOrganizationSchema, generateWebsiteSchema, generateFAQSchema, generateSoftwareApplicationSchema } from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";
import { initScrollTracking, initTimeOnPageTracking } from "@/utils/analytics";
import { businessFaqs as homeFaqs } from "@/components/BusinessFaq";


const Index = () => {
 const { language } = useLanguage();
 const structuredData = [
 generateOrganizationSchema,
 generateWebsiteSchema,
 generateFAQSchema(homeFaqs),
 generateSoftwareApplicationSchema,
 ];

 const location = useLocation();
 const navigate = useNavigate();

 // Route paid X/Twitter ad traffic to the dedicated landing page so it
 // gets a single-purpose, single-CTA experience instead of the full homepage.
 useEffect( () => {
 const params = new URLSearchParams(location.search);
 const src = (params.get("utm_source") || "").toLowerCase();
 if (src === "twitter" || src === "x") {
 navigate(`/lp/x${location.search}`, { replace: true });
 }
 }, [location.search, navigate]);

 useEffect( () => {
 const cleanupScroll = initScrollTracking();
 const cleanupTime = initTimeOnPageTracking();
 return () => {
 cleanupScroll();
 cleanupTime();
 };
 }, []);

 return (
 <>
 <SEO
 title="Stablecoin Business Payments — Pay Global Teams in USDC | Flip"
 description="Pay contractors and employees in 100+ countries with USDC. They receive USDC to their phone number, in 24 hours."
 canonical={language === 'ar' ? "https://www.theflip.app/ar" : undefined}
 keywords={["stablecoin business payments", "USDC business payments", "stablecoin payroll", "crypto payroll", "bulk stablecoin payments", "international contractor payments"]}
 structuredData={structuredData}
 lang={language}
 path="/"
 rawTitle
 />
 <div className="min-h-screen bg-flip-gradient">
 <Header />
 <main>
 <HeroSection />
 <Suspense fallback={null}>
 <DifferentiatorStrip />
 <ProblemSection />
 <HowItWorksSection />
 <WhyFlipSection />
 <UseCasesSection />
 <ComparisonTable />
 <DemoCTAModule />
 <LatestBlogPosts />
 <BusinessFaq page="home" variant="navy" />
 <FinalCTASection />
 </Suspense>
 </main>
 <Footer />
 
 </div>
 </>
 );
};

export default Index;
